import { useMemo } from 'react'
import { useLocation } from 'react-router'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

const homePageRoutes = [
  '/:regionCode/',
]

/**
 * Tells us whether we are currently on the home page or not
 */
function useIsHomePage() {
  const location = useLocation()
  return useMemo(() => {
    return !!matchLocaleAwarePath(location.pathname, { path: homePageRoutes, exact: true })
  }, [location.pathname])
}

export default useIsHomePage
